import React, { useState, useEffect, useRef, useContext, useMemo } from "react";

import axios from "axios";

import TextInput from "components/Input/TextInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import UserService from "services/UserService";
import Chip from "@mui/material/Chip";
import AdvancedSearchContext from "context/AdvancedSearchContext";

import { site } from "variables/patrimoine.js";
import { getSite, getFiles } from "services/ConfigServices";
import { makeStyles } from "@mui/styles";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


function Synthesis(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [other, setOther] = useState([]);
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleOtherChange = (newValue) => { setOther(newValue); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "equipments.synthesis"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setOther(res.data.detail.equipments.synthesis?.other || []);
        setAssociatedfiles(res.data.detail.equipments.synthesis?.associatedfiles);
        setComments(res.data.detail.equipments.synthesis?.comments);
        setDescription(res.data.detail.equipments.synthesis?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "equipments.synthesis"),
        {
          other,
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  const autocompleteOptions = [];
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <AutocompleteTagsInput
              inputTitle={site.equipments.synthesis.other}
              list={autocompleteOptions}
              selected={other}
              handleChange={handleOtherChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={site.equipments.synthesis.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.equipments.synthesis.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.equipments.synthesis.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export default Synthesis;